/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="95.59"
        height="84.31"
        viewBox="0 0 95.59 84.31"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M68.99.02a26.13 26.13 0 0 0-18 7.63l-3.24 3.25-3.24-3.25a26.29 26.29 0 0 0-37.18.1l-.26.27c-9.83 10.24-9.38 26.73.8 36.92l39 39a1.25 1.25 0 0 0 1.77 0l39-39c10.18-10.19 10.63-26.68.8-36.91a26.21 26.21 0 0 0-19-8Zm.47 2.5A23.71 23.71 0 0 1 86.63 9.8l.28.29c8.58 9.26 8.09 24-1 33.12L47.79 81.32 9.68 43.21C.5 34.02.04 19.02 8.91 9.8a23.79 23.79 0 0 1 33.63-.62l.24.24 4.13 4.13a1.27 1.27 0 0 0 1.77 0l4.12-4.13a23.56 23.56 0 0 1 16.7-6.9Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M71.32 15.11v9.19h9.19v10h-9.19v9.12h-10v-9.19h-9.18v-10h9.18v-9.19Z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
      </svg>

    );
  }
}

Icon.displayName = 'HeartWithCrossIcon';

export default Icon;
